import { render, staticRenderFns } from "./ExtratoFatura.vue?vue&type=template&id=14a273dc&scoped=true&"
import script from "./ExtratoFatura.vue?vue&type=script&lang=js&"
export * from "./ExtratoFatura.vue?vue&type=script&lang=js&"
import style0 from "./ExtratoFatura.vue?vue&type=style&index=0&id=14a273dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a273dc",
  null
  
)

export default component.exports